/*
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-12-22 15:31:04
 * @LastEditors: sen.yang
 * @LastEditTime: 2021-12-22 20:33:55
 */
import api from '@/api'
const state = {
    harvestAddress:{},//快递配送地址
    orderType:1,
}
const mutations = {
    setHarvestAddress:(state, address) => {
        state.harvestAddress = address
    },
    setOrdertype:(state, orderType) => {
        state.orderType = orderType
    },
}
const actions = {
    addOrUpdate({commit,state},params){
        return new Promise((res,rej)=>{
            let func = api.address.add
            if(params.id){
                func = api.address.update
            }
            func(params).then(({data})=>{
                commit('setHarvestAddress',data)
                res(data)
            })   
        })
    },
    deleteAddress({commit,state},params){
        return new Promise((res,rej)=>{
            api.address.deleteAddress(params).then(({data})=>{
                if(state.harvestAddress.id === params.id){
                    commit('setHarvestAddress',{})
                }
                res(data)
            })   
        })
    },
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}
  


// WEBPACK FOOTER //
// ./src/store/modules/address.js